import { useEffect, useState } from "react";
import { Tab } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import { customStyles } from "../Utility/Utility";
import Loader from "../Loader/Loader";


const UserActivityRules = () => {
  const [astroData, setAstroData] = useState([]);
  const [loading, setLoading] = useState(true);
  const[userActions,SetUserActions]=useState("")
  const[selectAction,setSelectAction]=useState("")
   const [startDate, setStartDate] = useState(new Date().toISOString().split("T")[0]);
  const [endDate, setEndDate] = useState(new Date().toISOString().split("T")[0]);
  const [id,setId]=useState("")

  const userdata = async () => {
    setLoading(true);
    try {
      const postdata = { UserId: id, UserAction: selectAction,CreatedAtFrom: startDate, CreatedAtTo: endDate };
      const res = await AddUpdate("UserActivityRules/Get_UserActivityLogs", postdata);
  

     const parsedData=JSON.parse(res?.data?.data ||"[]")
     const finaldata=parsedData?.Table || []
      setAstroData(finaldata|| []);
   
    } catch (err) {
      console.error("Error fetching user activity logs", err);
    } finally {
      setLoading(false);
    }
  };
  const drpdata=async()=>{
   try {
      const res = await AddUpdate("UserActivityRules/Drp_UserActivityLogs", {});
      

      
      const parsed = JSON.parse(res?.data?.data || "{}");
      const final=parsed?.Table || []
   

      SetUserActions(final|| []);
      
    } catch (error) {
  console.error("Error fetching user actions:", error);
}

  }

  useEffect(() => {
    userdata();
    drpdata();
  }, []); 
 
  const columns=[
    {name:"ID", selector:row=>row?.UserId, sortable:true,width:"60px"},
    {name:"Name", selector:row=>row?.NickName, sortable:true},
    {name:"Mobileno", selector:row=>row?.MobileNo, sortable:true},
    {name:"Action", selector:row=>row?.Action, sortable:true},   
    {name:"Description", selector:row=>row?.Description, sortable:true},
    {name:"UserAgent", selector:row=>row?.UserAgent, sortable:true},   
   {
  name: "Created At",
  selector: (row) => row?.CreatedAt ? new Date(row.CreatedAt).toLocaleDateString() : "",
  sortable: true
},

    {
  name: "Next Log Time",
  selector: (row) => row?.NextLogTime 
    ? new Date(row.NextLogTime).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) 
    : "",
  sortable: true
},

  {
  name: "Time Diff",
  selector: (row) => {
    if (!row?.TimeDiffFormatted) return "";

    const parts = row.TimeDiffFormatted.split(" "); 
   

    let result = [];

    for (let i = 0; i < parts.length; i += 2) {
      const value = parseInt(parts[i], 10);
      const label = parts[i + 1];

      if (label === "Seconds") {
      
        result.push(`${value} ${label}`);
      } else if (value > 0) {
       
        result.push(`${value} ${label}`);
      }
    }

    return result.join(" ");
  },
  sortable: true,
}


  ]


  return (
    <>
      <h2 style={{ color: "#f7931e", fontWeight: 700 }}>User Activity Rules</h2>


<div className="d-flex align-items-center gap-2 mb-3">
 
  <select
    style={{ height: "40px" }}
    className="form-select w-auto"
    value={selectAction}
    onChange={(e) => setSelectAction(e.target.value)}
  >
    <option value="">Select User Action</option>
    {Array.isArray(userActions) &&
      userActions.map((item, index) => (
        <option key={index} value={item?.Action}>
          {item?.Action}
        </option>
      ))}
  </select>

 
 



  <div className="d-flex align-items-end gap-3 mb-3">
 
  <div className="d-flex flex-column">
    <label style={{color:"black"}} className="mb-1 fw-semibold">Start Date</label>
    <input
      type="date"
      className="form-control w-auto"
      value={startDate}
      onChange={(e) => setStartDate(e.target.value)}
      style={{ height: "40px" }}
    />
  </div>


  <div className="d-flex flex-column">
    <label style={{color:"black"}} className="mb-1 fw-semibold">End Date</label>
    <input
      type="date"
      className="form-control w-auto"
      value={endDate}
      onChange={(e) => setEndDate(e.target.value)}
      style={{ height: "40px" }}
    />
  </div>


  <div className="d-flex flex-column">
    <label style={{color:"black"}} className="mb-1 fw-semibold">User ID</label>
    <input
      type="text"
      className="form-control w-auto"
      value={id}
      placeholder="Enter User ID"
      onChange={(e) => setId(e.target.value)}
      style={{ height: "40px" }}
    />
  </div>
</div>
 
  <button className="btn btn-primary" style={{ height: "40px" }} onClick={userdata}>
    Search
  </button>
</div>



      <div className="row mt-4">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <Tab.Content>
                
                {loading ? (<Loader/>):(
                  <div className="table-responsive">
                    <DataTable
                      dense
                      data={astroData||[]}
                      columns={columns}
                      progressPending={loading}
                      selectableRowsHighlight
                      highlightOnHover
                      pagination
                      persistTableHead={true}
                      noDataComponent={"There are no data to display"}
                      customStyles={customStyles}
                    />
                  </div>
                  )}
              
              </Tab.Content>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserActivityRules;
